import React from 'react'
import cn from 'classnames'
import { SocialShareData, SocialShareType } from '@components/share-widget/types'
import { IconButton } from '@components/ui-lib/button/icon-button'
import { Email, Facebook, FacebookMessenger, Instagram, LinkedIn, X } from '@components/ui-lib/icons/social-share'
import { Text } from '@grammarly/design-system'
import { useIsSectionThemeDark } from '@contexts/section-theme-context'
import { socialShare } from './utils/social-share'
import styles from './social-share-button.module.scss'

export interface SocialShareButtonProps {
  type: SocialShareType
  data: SocialShareData
}

const SocialIcon: Record<SocialShareType, React.ReactNode> = {
  [SocialShareType.X]: <X />,
  [SocialShareType.Facebook]: <Facebook />,
  [SocialShareType.FacebookMessenger]: <FacebookMessenger />,
  [SocialShareType.LinkedIn]: <LinkedIn />,
  [SocialShareType.Email]: <Email />,
  [SocialShareType.Instagram]: <Instagram />,
}

const label: Record<SocialShareType, string> = {
  [SocialShareType.Facebook]: 'Share on Facebook',
  [SocialShareType.LinkedIn]: 'Share on LinkedIn',
  [SocialShareType.X]: 'Share on X',
  [SocialShareType.FacebookMessenger]: 'Share on Messenger',
  [SocialShareType.Instagram]: 'Share on Instagram',
  [SocialShareType.Email]: 'Share by Email',
}

export const SocialShareButton: React.FC<SocialShareButtonProps> = ({ type, data }) => {
  const isDarkThemeSection = useIsSectionThemeDark()

  const handleClick = () => {
    socialShare(type, data)
  }

  return (
    <IconButton
      className={cn(styles.shareButton, {
        [styles.darkTheme]: isDarkThemeSection,
      })}
      onClick={handleClick}
      tooltip={{
        content: (
          <Text as="span" variant="text-xsmall">
            {label[type]}
          </Text>
        ),
        lightTheme: isDarkThemeSection,
      }}
      aria-label={label[type]}
    >
      {SocialIcon[type]}
    </IconButton>
  )
}
